module.exports = __webpack_public_path__ + "static/media/image_29.f7d0271b.png";